import { render, staticRenderFns } from "./ChildrenArray.vue?vue&type=template&id=64effcc1&"
import script from "./ChildrenArray.vue?vue&type=script&lang=ts&"
export * from "./ChildrenArray.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports